import type { DealView } from "@meksiko/shared-types";

// Shared by render.ts (whose turn to highlight/enable controls for) and
// audio/sfx.ts (whether a state push means "it just became my turn").
export function actingSeat(deal: DealView): 0 | 1 | 2 | null {
  switch (deal.phase) {
    case "bidding":
      return deal.bidding.turn;
    case "discarding":
    case "choosingTrump":
      return deal.bidWinner;
    case "playing":
      return deal.currentTrick?.turn ?? null;
    default:
      return null;
  }
}
